import React, { Component } from 'react';
import API from '../../../api/api';
import './list.less';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button, Input, message, Popconfirm, ConfigProvider } from 'antd';
class ChatSensitiveWords extends Component {

    constructor(props) {
        super(props);
    }

    state = {
        pagination: {
            hideOnSinglePage: false,
            showQuickJumper: false,
            showSizeChanger: false,
            addModalTitle: '',
            pageSize: 10,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
            position: 'bottom',
        },
        mainShopList: [
            {
                shopName: '华贸',
                shopAddress: '就啊纠结啊姐',
                location: "2021-03-11 20:36:44",
                adminPhones: '183423432432',
                templateId: '20',
                currMonthUseAmount: '4500'
            },
        ],
        columns: [
            {
                title: '商家名称',
                dataIndex: 'shopName',
                key: 'shopName',
            },
            {
                title: '商家地址',
                dataIndex: 'shopAddress',
                key: 'shopAddress',
            },
            {
                title: '管理员手机',
                dataIndex: 'adminPhones',
                key: 'adminPhones',
            },
            {
                title: '本月核销金额(元)',
                key: 'currMonthUseAmount',
                render: (data) => (
                    <span>{data.currMonthUseAmount/100}</span>
                )
            },
            {
                title: '操作',
                key: 'isFreeze',
                render: (data) => (
                    <div className="operateBtnBlock">
                        <Button key={'unFreezeBtn' + data.userId} onClick={this.goDetail.bind(this, data)} className="deleteBtn" style={{ marginRight: '10px' }}>详情</Button>
                        <Popconfirm title="确定删除该商家吗？"
                            onConfirm={this.deleteFuncOrDis.bind(this, data)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button key={'unFreezeBtn' + data.userId} type="primary" className="deleteBtn">删除</Button>
                        </Popconfirm>
                    </div>
                ),
            },
        ],

        searchCondition: {
            pageNo: 1,
            pageSize: 10,
            phone: '',
            shopName: '',
        }


    }

    componentDidMount() {
        this.getListData('homePage')
    }

    async getListData(type) {
        let { pagination, searchCondition } = this.state;
        if ('homePage' == type) {
            searchCondition.pageNo = 1
            pagination.current = 1
        }
        let result = await API.couponMainShopList(searchCondition);
        if (result.status == 1) {
            let mainList = result.data.mainShopList;
            pagination.total = Number(result.data.total);
            this.setState({
                pagination,
                mainList
            })
        }
    }

    addShop() {
        this.props.history.push({ pathname: "/themeFlightShopDetail", state: { isNew: true } })
    }

    goDetail(item) {
        console.log('item', item)
        this.props.history.push({ pathname: "/themeFlightShopDetail", state: { isNew: false, templateId: item.templateId } })
    }

    async deleteFuncOrDis(data) {
        let result = await API.couponDeleteShop({
            templateId: data.templateId
        })
        if (result.status == 1) {
            message.success('删除成功');
            this.getListData();
            return;
        }
        message.error(result.msg);
    }

    handleTableChange = (pagination) => {
        let { searchCondition } = this.state;
        console.log('pagination.current', pagination.current)
        searchCondition.pageNo = pagination.current;
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
            searchCondition
        }, () => {
            this.getListData();
        });
    };

    onShowSizeChange = (current, pageSize) => {
        let { searchCondition, pagination } = this.state;
        pagination.pageSize = pageSize
        pagination.current = 1
        searchCondition.pageSize = pageSize;
        searchCondition.pageNo = 1;
        this.setState({
            pagination,
            searchCondition
        }, () => {
            this.getListData();
        });
    }



    InputItemChange(target, e) {
        let value = e.target.value.trim();
        console.log('value', e)
        let { searchCondition } = this.state;
        searchCondition[target] = value
        console.log('searchCondition', searchCondition)
        this.setState({ searchCondition })
    }


    searchForData() {//搜索
        this.getListData('homePage');
    }

    reset() {
        this.setState({
            searchCondition: {
                pageNo: 1,
                pageSize: 10,
                phone: '',
                shopName: '',
            }
        }, () => {
            this.getListData('homePage');
        })
    }

    render() {
        const {
            columns,
            mainList,
            pagination,
            searchCondition
        } = this.state;
        return (
            <ConfigProvider locale={zhCN}>
                <div className={`chatSensitiveWords  `}>
                    <Button type="primary" className='sensitive-btn' onClick={this.addShop.bind(this)}>添加商家</Button>
                    <div className='search-model'>
                        <Input className='input-userId' value={searchCondition.shopName} onChange={this.InputItemChange.bind(this, 'shopName')} placeholder="商家名称"></Input>
                        <Input className='input-userId' value={searchCondition.phone} onChange={this.InputItemChange.bind(this, 'phone')} placeholder="管理员手机"></Input>
                        <Button type="primary" onClick={this.searchForData.bind(this)}>搜索</Button>
                        <Button type="primary" onClick={this.reset.bind(this)} style={{ marginLeft: '20px' }}>重置</Button>
                    </div>
                    <Table columns={columns}
                        dataSource={mainList}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                        onShowSizeChange={this.onShowSizeChange}
                        rowKey={(row, index) => row.userId + '-' + index}
                    />
                </div>
            </ConfigProvider>
        )
    }
}

export default ChatSensitiveWords;